import { forwardRef, useTagStyles } from '@chakra-ui/react-v2';
import { cx } from '@chakra-ui/utils';

import {
  Icon,
  type IconProps,
} from '@frontend/legacy-components/src/components/mediaAndIcons/icons';

export type TagIconProps = IconProps;

export const TagIcon = forwardRef<TagIconProps, 'svg'>(
  ({ className, ...restProps }, ref) => {
    const styles = useTagStyles();

    return (
      <Icon
        className={cx('tag__icon', className)}
        ref={ref}
        __css={styles.icon}
        {...restProps}
      />
    );
  },
);
